import React, {useState, useEffect} from 'react';
import {
  FaArrowLeft,
  FaTimes,
  FaPlus,
  FaTimesCircle,
  FaCheck,
} from 'react-icons/fa';
import {useNavigate, useLocation} from 'react-router-dom';
import Get from './components/Get';
import Post from './components/Post';

const PostFree = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = location.state?.data || {};
  const [walletBalance, setWalletBalance] = useState(0);
  const [checked, setChecked] = useState(false);
  const [numbers1, setNumbers1] = useState('');
  const [numbers2, setNumbers2] = useState('');
  const [amounts, setAmounts] = useState('');
  const [error, setError] = useState(null);
  const [fk_game_timer_id, setFkGameTimerId] = useState(null);
  const [bidding_type] = useState('crossing');
  const [gameName, setGameName] = useState('Crossing');
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (params.id) {
      setFkGameTimerId(params.id);
      setGameName(params.name?.name || 'Crossing');
    }
    wallet();
  }, [params.id, params.name?.name]);

  // Automatically recalculate total whenever data changes
  useEffect(() => {
    const newTotal = data.reduce(
      (acc, curr) => acc + parseFloat(curr.amount || 0),
      0,
    );
    setTotal(newTotal);
  }, [data]);

  const wallet = () => {
    Get.Wallet().then(res => {
      if (res.wallet) {
        setWalletBalance(res.wallet.balance);
      }
    });
  };

  const add = (useChecked = checked) => {
    const is_double = useChecked ? 1 : 0;
    const value1 = numbers1;
    const value2 = numbers2;

    setError(null);

    if (value1 && value2 && amounts) {
      if (/^[0-9]*$/.test(value1) && /^[0-9]*$/.test(value2)) {
        const firstArray = value1.split('');
        const secondArray = value2.split('');
        const newArray = [];

        firstArray.forEach(f => {
          secondArray.forEach(s => {
            if (f === '0' && s === '0') {
              newArray.push(100);
            } else {
              if (is_double === 1) {
                if (f !== s) {
                  newArray.push(parseInt(f + s));
                }
              } else {
                newArray.push(parseInt(f + s));
              }
            }
          });
        });

        const newData = [];
        newArray.forEach(d => {
          newData.push({number: d, amount: amounts, type: 'j'});
        });

        setData(newData);
      } else {
        setError('Please Input Only Numbers');
      }
    } else {
      window.alert('Required: Please enter all numbers and the amount.');
    }
  };

  const submit = () => {
    if (!fk_game_timer_id) {
      window.alert('Error: Game ID is missing. Please try again.');
      return;
    }

    if (data.length === 0) {
      window.alert('Please add at least one bet before submitting.');
      return;
    }

    Post.Bidding({
      total,
      data,
      walletBalance,
      checked,
      numbers1,
      numbers2,
      amounts,
      error,
      fk_game_timer_id,
      bidding_type,
      gameName,
    }).then(res => {
      if (res.success) {
        setData([]);
        setNumbers1('');
        setNumbers2('');
        setAmounts('');
        setTotal(0);
        window.alert('Success: Your Crossing bet has been submitted.');
        wallet();
      } else {
        window.alert(
          'Error: ' + (res.errorMsg || 'An unknown error occurred.'),
        );
      }
    });
  };

  const removeItem = index => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(-1)}>
          <FaArrowLeft size={20} />
        </button>
        <h1 style={styles.headerTitle}>{gameName}</h1>
        <div style={{width: '40px'}} />
      </div>

      {/* Content */}
      <div style={styles.content}>
        {/* Input Card */}
        <div style={styles.card}>
          <div style={styles.row}>
            <input
              type="text"
              placeholder="Digits A"
              value={numbers1}
              onChange={e => setNumbers1(e.target.value)}
              style={styles.input}
            />
            <div style={styles.icon}>
              <FaTimes size={20} />
            </div>
            <input
              type="text"
              placeholder="Digits B"
              value={numbers2}
              onChange={e => setNumbers2(e.target.value)}
              style={styles.input}
            />
          </div>
          <input
            type="text"
            placeholder="Enter Amount"
            value={amounts}
            onChange={e => setAmounts(e.target.value)}
            style={styles.inputFull}
          />
          {error && <p style={styles.error}>{error}</p>}
          <div style={styles.checkboxRow}>
            <input
              type="checkbox"
              checked={checked}
              onChange={e => {
                setChecked(e.target.checked);
                add(e.target.checked);
              }}
            />
            <label style={styles.checkboxLabel}>
              Don't include pairs (e.g., 11, 22)
            </label>
          </div>
          <button onClick={() => add()} style={styles.addButton}>
            <FaPlus />
            <span style={{marginLeft: '8px'}}>Generate & Add Bets</span>
          </button>
        </div>

        {/* Bets List */}
        {data.length > 0 && (
          <div style={styles.card}>
            <div style={styles.listHeader}>
              <div style={styles.col}>Type</div>
              <div style={styles.colCenter}>Number</div>
              <div style={styles.colCenter}>Amount</div>
              <div style={styles.colAction}>Del</div>
            </div>
            {data.map((item, index) => (
              <div key={index} style={styles.listRow}>
                <div style={styles.col}>
                  {item.type === 'j'
                    ? 'Jodi'
                    : item.type === 'a'
                    ? 'Andar'
                    : 'Bahar'}
                </div>
                <div style={styles.colCenterHighlight}>{item.number}</div>
                <div style={styles.colCenter}>₹{item.amount}</div>
                <div style={styles.colAction}>
                  <button
                    onClick={() => removeItem(index)}
                    style={styles.deleteBtn}>
                    <FaTimesCircle size={22} color="#EF4444" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Bottom Bar */}
      {data.length > 0 && (
        <div style={styles.bottomBar}>
          <div style={styles.totalBox}>
            <div style={styles.totalAmount}>₹{total || '0'}</div>
            <div style={styles.totalText}>Total Amount</div>
          </div>
          <button onClick={() => submit()} style={styles.submitBtn}>
            <FaCheck />
            <span style={{marginLeft: '8px'}}>Submit Bets</span>
          </button>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    background: '#f9fafb',
    minHeight: '100vh',
  },
  header: {
    background: '#1d4ed8',
    color: '#fff',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  backButton: {
    padding: '8px 10px',
    background: 'rgba(255,255,255,0.2)',
    borderRadius: '50%',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
  },
  headerTitle: {fontSize: '18px', fontWeight: 'bold'},
  content: {flex: 1, padding: '16px', overflowY: 'auto'},
  card: {
    background: '#fff',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    marginBottom: '16px',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'center',
  },
  input: {
    flex: 1,
    padding: '12px 10px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    width: '100%',
  },
  inputFull: {
    width: '94%',
    margin: '15px 0px',
    padding: '12px 10px',
    border: '1px solid #ccc',
    borderRadius: '6px',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    color: '#1d4ed8',
    padding: '0 4px',
  },
  error: {color: 'red', fontSize: '14px'},
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    margin: '16px 0px',
    gap: '6px',
  },
  checkboxLabel: {fontSize: '14px', color: '#374151'},
  addButton: {
    width: '100%',
    marginTop: '10px',
    padding: '12px',
    background: '#1d4ed8',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  listHeader: {
    display: 'flex',
    paddingBottom: '6px',
    borderBottom: '1px solid #ccc',
    fontWeight: '600',
    fontSize: '14px',
    color: '#555',
  },
  listRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #eee',
    fontSize: '14px',
  },
  col: {flex: 1},
  colCenter: {flex: 1, textAlign: 'center'},
  colCenterHighlight: {
    flex: 1,
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#d97706',
  },
  colAction: {width: '40px', textAlign: 'right'},
  deleteBtn: {background: 'none', border: 'none', cursor: 'pointer'},
  bottomBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    borderTop: '1px solid #ccc',
    background: '#fff',
    boxShadow: '0 -2px 6px rgba(0,0,0,0.1)',
  },
  totalBox: {
    flex: 1,
    background: '#fde68a',
    padding: '10px',
    border: '1px solid #facc15',
    borderRadius: '6px',
    textAlign: 'center',
  },
  totalAmount: {fontWeight: 'bold', color: '#1d4ed8', fontSize: '16px'},
  totalText: {fontSize: '12px', color: '#555'},
  submitBtn: {
    flex: 1,
    background: '#22c55e',
    color: '#fff',
    padding: '12px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default PostFree;
